import { createGtm } from '@gtm-support/vue-gtm';
import type { FunctionPlugin } from 'vue';

export interface GtmTrackerPluginOptions {
  id: string[];
  enabled: boolean;
  debug: boolean;
  loadScript: boolean;
}

const GtmTrackerPlugin: FunctionPlugin<GtmTrackerPluginOptions> = function (app, options) {
  const gtm = createGtm(options);

  app.use(gtm);
};

export default GtmTrackerPlugin;
